var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBodymap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 42,
    height: 42,
    rx: 21,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_31785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2241 30.2259C19.3522 31.2088 20.1877 31.9787 21.126 31.9787H23.5885C24.5268 31.9787 25.3622 31.2088 25.4892 30.2347L26.3983 23.8455L28.2664 22.6855C28.5247 22.5252 28.6638 22.2272 28.6209 21.926L27.9244 17.0408C27.6465 15.2108 26.0173 13.7219 24.2925 13.7219H24.2287C23.6643 14.0034 23.0291 14.1626 22.3572 14.1626C21.6854 14.1626 21.0502 14.0035 20.4858 13.7219H20.422C18.6972 13.7219 17.0679 15.2108 16.7888 17.0479L16.0936 21.9261C16.0507 22.2272 16.1896 22.5252 16.4479 22.6856L18.3161 23.8456L19.2241 30.2259Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3573 12.8421C23.9601 12.8421 25.2595 11.5343 25.2595 9.92105C25.2595 8.3078 23.9601 7 22.3573 7C20.7544 7 19.4551 8.3078 19.4551 9.92105C19.4551 11.5343 20.7544 12.8421 22.3573 12.8421Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2406 27.299L26.7973 30.4144C26.6941 31.1898 26.3176 31.9103 25.7365 32.4443C25.1365 32.9955 24.3737 33.299 23.5886 33.299H21.1261C20.3399 33.299 19.5764 32.9946 18.9765 32.4417C18.3962 31.9067 18.0197 31.184 17.9162 30.4054L17.4818 27.3521C14.5102 27.9446 12.2207 29.1187 12.2207 30.9448C12.2207 33.731 17.5491 35 22.4999 35C27.4507 35 32.7791 33.731 32.7791 30.9449C32.7791 29.0623 30.346 27.8726 27.2406 27.299Z",
    fill: "#00994E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_31785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodymap);
export default __webpack_public_path__ + "static/media/bodymap.63ba5ea1d70b45a78e1bf71930b9791a.svg";
export { ForwardRef as ReactComponent };